<template>
  <div
    class="ask-anything-icon"
    :class="`variant-${variant}`"
  >
    <img
      :src="src"
      alt="AskAnything Icon"
    >
  </div>
</template>

<script>
export default {
  name: 'AskAnythingIcon',
  props: {
    variant: {
      type: String,
      default: 'icon',
    },
  },
  computed: {
    src() {
      return `${this.$root.$data.STATIC_ROOT}images/ask-anything/ask-anything-${this.variant}.png`;
    },
  },
};
</script>

<style scoped>
.ask-anything-icon {
  --d: 36px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-self: center;
  height: var(--d);
  width: var(--d);

  &.variant-logo {
    --d: 120px;
  }
}
</style>
